module.exports = __webpack_public_path__ + "assets/cf4974a3a2f6ba3f54f46e357d2a41d0.png";